import { render, staticRenderFns } from "./ProfileRecommendations.vue?vue&type=template&id=63a2e478&scoped=true"
import script from "./ProfileRecommendations.vue?vue&type=script&lang=js"
export * from "./ProfileRecommendations.vue?vue&type=script&lang=js"
import style0 from "./ProfileRecommendations.vue?vue&type=style&index=0&id=63a2e478&prod&lang=scss&scoped=true"
import style1 from "./ProfileRecommendations.vue?vue&type=style&index=1&id=63a2e478&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a2e478",
  null
  
)

export default component.exports